<template>
  <b-card title="Edit Applied Equipment Warranty">
    <b-col cols="12">
      <label>Project Name<span style="color:red">(*)</span></label>
      <b-form-input
        placeholder="Applied Equipment Warranty Name"
        v-model="equipment.name"
      ></b-form-input>
    </b-col>

    <b-col cols="12">
      <label>Address<span style="color:red">(*)</span></label>
      <b-form-input
        placeholder="Applied Equipment Warranty Address"
        v-model="equipment.address"
      ></b-form-input>
    </b-col>
    <b-col cols="12">
      <label>Postal<span style="color:red">(*)</span></label>
      <b-form-input
        placeholder="Applied Equipment Warranty Postal Code"
        v-model="equipment.postalCode"
      ></b-form-input>
    </b-col>
    <b-col cols="12">
      <label>Country<span style="color:red">(*)</span></label>
      <b-form-input
        list="list-country"
        placeholder="Applied Country"
        v-model="equipment.country"
      ></b-form-input>
      <b-form-datalist
        id="list-country"
        :options="equipmentCountry"
      ></b-form-datalist>
    </b-col>

    <b-col cols="12">
      <label>Applied Customer<span style="color:red">(*)</span></label>
      <b-form-input
        v-model="equipment.developer"
        placeholder="Applied Customer Name"
      ></b-form-input>
    </b-col>

    <!-- <b-col cols="12">
      <label>Address 1<span style="color:red">(*)</span></label>
      <b-form-input
        v-model="equipment.devAddress1"
        placeholder="Developer Address Line 1"
      ></b-form-input>
    </b-col>

    <b-col cols="12">
      <label>Address 2</label>
      <b-form-input
        v-model="equipment.devAddress2"
        placeholder="Developer Address Line 2"
      ></b-form-input>
    </b-col>

    <b-col cols="12">
      <label>Developer Postal<span style="color:red">(*)</span></label>
      <b-form-input
        placeholder="Developer Postal Code"
        v-model="equipment.devPostalCode"
      ></b-form-input>
    </b-col>
    <b-col cols="12">
      <label>Developer Country<span style="color:red">(*)</span></label>
      <b-form-input
        list="list-developer-country"
        placeholder="Developer Country"
        v-model="equipment.devCountry"
      ></b-form-input>
      <b-form-datalist
        id="list-developer-country"
        :options="devEquipmentCountry"
      ></b-form-datalist>
    </b-col> -->

    <b-col cols="12">
      <label>Warranty Duration<span style="color:red">(*)</span></label>
      <b-form-select
        v-model="equipment.warrantyDuration"
        :options="warrantyDurations"
      ></b-form-select>
    </b-col>

    <b-col cols="12">
      <label>Email<span style="color:red">(*)</span></label>
      <b-form-input
        placeholder="Equipment Email"
        type="email"
        v-model="equipment.email"
      ></b-form-input>
    </b-col>

    <b-col cols="12">
      <b-row class="hide-on-mobile">
            <!-- <b-col cols="6">
                <label>Start Date <span style="color:red">(*)</span></label>
                <b-form-datepicker v-model="equipment.startDate" class="mb-2"></b-form-datepicker>
            </b-col> -->

            <b-col cols="12">
                <label>Commissioning Date <span style="color:red">(*)</span></label>
                <b-form-datepicker v-model="equipment.topDate" class="mb-2"></b-form-datepicker>
            </b-col>
            </b-row>
            <b-row class="hide-on-desktop">
            <!-- <b-col cols="12">
                <label>Start Date <span style="color:red">(*)</span></label>
                <b-form-datepicker v-model="equipment.startDate" class="mb-2"></b-form-datepicker>
            </b-col> -->

            <b-col cols="12">
                <label>Commissioning Date <span style="color:red">(*)</span></label>
                <b-form-datepicker v-model="equipment.topDate" class="mb-2"></b-form-datepicker>
            </b-col>
            </b-row>
    </b-col>

    <!-- <b-col cols="12">
      <b-row class="hide-on-mobile">
            <b-col cols="10">
            <label>Delivery Order Number<span style="color:red">(*)</span></label>
            <b-form-input  v-model="delivOrder" placeholder="Delivery order" ></b-form-input>
            </b-col>
            <b-col cols="2">
                <b-button class="mt-2" variant="primary" @click="fillDo">Search</b-button>
            </b-col>
            </b-row>
            <b-row class="hide-on-desktop">
            <b-col cols="12">
            <label>Delivery Order Number<span style="color:red">(*)</span></label>
            <b-form-input  v-model="delivOrder" placeholder="Delivery order" ></b-form-input>
            </b-col>
            <b-col cols="2">
                <b-button class="mt-2" variant="primary" disabled @click="fillDo">Search</b-button>
            </b-col>
            </b-row>
    </b-col> -->

    <b-col cols="12" class="my-1">
      <b-table :items="equipment.selectedDo" :fields="doFields" show-empty>
        <template #cell(customer)="row">
          {{ row.item.CustomerName1 }} {{ row.item.CustomerName2 }}
        </template>
      </b-table>
    </b-col>


    <b-col cols="12" class="my-2 section-data">
      <h5>Product Registered</h5>
      <b-table :items="equipment.items" :fields="itemFields" show-empty responsive>
        <template #cell(generalEndWarranty)="row">
          {{ row.item.generalEndWarranty | formatDate }}
        </template>
        <template #cell(compressorEndWarranty)="row">
          {{ row.item.compressorEndWarranty?row.item.compressorEndWarranty:'-' | formatDate }}
        </template>
        <template #cell(residentialEndWarranty)="row">
          {{ row.item.residentialEndWarranty?row.item.residentialEndWarranty:'-' | formatDate }}
        </template>
      </b-table>
    </b-col>

    <b-col cols="12" class="mt-2">
      <b-button variant="success" @click="doUpdateEquipment">Update</b-button>
      <!-- <b-button @click="test">test</b-button> -->
    </b-col>
  </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import axios from '@/axios';
import { sleep,dateFormat }from '@/utils/utils.js'
export default {
    data() {
        return {
            delivOrder:'',
            equipment: {
                name: '',
                address: '',
                email: '',
                developer: null,
                saleOrder: null,
                topDate: null,
                warrantyDuration: null,
                postalCode:'',
                country: '',
                // devAddress1:'',
                // devAddress2:'',
                // devPostalCode:'',
                // devCountry:'',
                selectedDo:[],
                items:[]
            },
            warrantyDurations: [
                { value: 12, text: '12 Months' },
                // { value: 15, text: '15 Month' },
                { value: 18, text: '18 Month' }
            ],
            doFields: [
                { key: 'sapDo', label: 'DO Number' },
                { key: 'sapSo', label: 'SO Number' },
                { key: 'dealerNo', label: 'Dealer Code' },
                // { key: 'action', label: 'Action' },      
            ],
            itemFields: [
                { key: 'itemModel', label: 'Model' },
                { key: 'serial', label: 'Serial' },
                { key: 'barcode', label: 'Barcode' },
                { key: 'pcode', label: 'Pcode' },
                { key: 'status', label: 'Status' },
                { key: 'sapDo', label: 'DO Number' },
                { key: 'generalEndWarranty', label: 'Applied General Warranty End' },
                { key: 'compressorEndWarranty', label: 'Compressor Warranty End' },      
                 
            ],
            equipmentCountry: ["Singapore"],
            devEquipmentCountry: ["Singapore"],
            selectedSaleOrder: null,
            doList: [],
        }
    },
    mounted() {


        this.getEquipment(this.$route.params.id).then((res) => {
            this.equipment = res;

        }).catch((e) => {
            console.log(e)
        });


    },
    methods: {
        ...mapActions({
            getEquipment: 'equipmentWarranty/getEquipment',
            updateEquipment: 'equipmentWarranty/updateEquipment',
            getListDo: 'projectWarranty/getListDo',
            searchSO: 'projectWarranty/searchSO'
        }),
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        // test(){
        //     console.log('hasil equipment',this.equipment)
        // },
        fillDo() {
            const sameDO= this.equipment.selectedDo.some(x => x.sapDo=== this.delivOrder)
            console.log({sameDO})
            if(sameDO) {
            this.$bvToast.toast("Cannot add same DO Number", {
                        title: "DO number has been added to the list ",
                        variant: "danger",
                        solid: true,
                    });
                
                this.delivOrder=''
            }
            if(!sameDO) {
          this.verifyDo({sapDo:this.delivOrder}).then((res) => {
                // console.log(res)
                this.equipment.selectedDo.push({
                    sapDo:res.sapDo,
                    sapSo:res.sapSo,
                    pcode:res.pcode,
                    dealerNo:res.dealerNo
                    })


                this.$bvToast.toast('Delivery Order Found', {
                        title: "Success",
                        variant: "success",
                        solid: true,
                    });
                this.delivOrder = ''
            }).catch((e) =>{
                console.log({e})
                this.$bvToast.toast(e.response.data.errors[0].message, {
                        title: "Failed",
                        variant: "danger",
                        solid: true,
                    });
                
                this.delivOrder=''
            })
        }           
                // console.log('selected SO',this.selectedSaleOrder)   
        },
        doUpdateEquipment() {
          let { _id } = this.equipment;
          delete this.equipment.selectedDo;
          delete this.equipment.items;
          delete this.equipment.updatedAt;
            axios.put(`sales-and-purchase/equipment-warranty/${_id}`,this.equipment).then(async (equipment) => {
              console.log({equipment})
              this.equipment = equipment;
              this.$bvToast.toast(`Update Applied Equipment Warranty Successfully`, {
                title: "Success",
                variant: "success",
                solid: true,
              });
              await this.sleep(3000)
              this.$router.go(-1);
            }).catch((e) => {
                console.log({e});
                if(e.request.status === 400){
                    this.$bvToast.toast(`${e.response.data.errors[0].message}`, {
                    title: "Failed",
                    variant: "danger",
                    solid: true,
                });}
                else
                {this.$bvToast.toast(`${e.response.data.message}`, {
                    title: "Failed",
                    variant: "danger",
                    solid: true,
                    });}
            });
        }
    }
}
</script>
<style scoped>

.section-data {
  padding: 15px 10px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  position: relative;
  margin: 20px 0 20px 0;
}

.section-data h5 {
  position: absolute;
  top: -10px;
  left: 6px;
  background: white;
  padding: 0 10px;
}

@media (max-width : 761px){
  .hide-on-mobile {display: none !important;}
}
@media (min-width : 762px){
  .hide-on-desktop {display: none !important;}
}
</style>
